export default "__VITE_ASSET__BZUzY$TF__"